export default __webpack_public_path__ + "static/media/home_modal_regional_norte.d65e7113.png";